// Labels every team profile shares, Finnish: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Henkilötiedot',
    rows: {
      name: 'Nimi',
      position: 'Tehtävä',
      birthdate: 'Syntymäaika',
      nationality: 'Kansalaisuus',
      maritalStatus: 'Siviilisääty',
      location: 'Sijainti',
      languages: 'Kielet',
      programmingLanguages: 'Ohjelmointikielet',
      certifications: 'Sertifikaatit',
      publications: 'Julkaisut',
      links: 'Verkkosivusto'
    }
  },
  education: {
    title: 'Koulutus'
  },
  skills: {
    title: 'Erityisosaaminen'
  },
  experience: {
    title: 'Projektit ja tehtävät',
    techLabel: 'Teknologiat'
  },
  downloads: {
    title: 'Lataa profiili',
    deLabel: 'Lataa saksankielinen profiili',
    deDescription: 'PDF saksaksi',
    enLabel: 'Lataa englanninkielinen CV',
    enDescription: 'PDF englanniksi'
  },
  cta: {
    title: 'Yhteystiedot',
    button: 'Ota yhteyttä'
  },
  pdf: {
    title: 'Profiili',
    personalSection: 'Henkilötiedot',
    educationSection: 'Koulutus',
    experienceSection: 'Projektit ja tehtävät',
    skillsLabel: 'Osaaminen'
  }
};
